import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import M from 'materialize-css/dist/js/materialize';
import { translate, isNullOrEmpty } from '../../../utils/util';
import { Input, BackButton, Title, Button, ListPaginationNew } from '../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../utils/handleChangeHooks';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import ErrorShedMonitorItem from './ErrorShedMonitorItem'

const ErrorShedMonitorList = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [filter, setFilter] = useState(
        {
            success: false,
            dateStart: undefined,
            dateEnd: undefined,
            transmissiontype: 9, //without MVM
            partnumber: undefined,
            shed: undefined,
            message: "Desenho não pode ser recebido no galpão",
            excluded: true
        });
    const [transmissions, setTransmissions] = useState([]);
    const [instanceM, setInstanceM] = useState();

    useEffect(() => {
        if (props.transmissions?.items?.length > 0) {
            if (transmissions.length > 0 && currentPage === 0) {
                setTransmissions([...props.transmissions.items]);
            } else {
                setTransmissions((prevState) => ([...prevState, ...props.transmissions.items]));
            }
        } else {
            setTransmissions([]);
        }
        // eslint-disable-next-line
    }, [props?.transmissions?.items]);

    const getTransmissionFilter = () => {

        props.getTransmissions(Object.assign(filter, {
            PageSize: 25,
            PageIndex: currentPage
        }), (data) => {
            if (instanceM) {
                instanceM[1].close();
            }
        });
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    useEffect(() => {
        const instance = M.Collapsible.init(document.querySelectorAll('.collapsible'), {
            accordion: false
        });
        setInstanceM(instance);
        getTransmissionFilter(false, false)
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (currentPage > 0) {
            getTransmissionFilter(false, false);
        }
        // eslint-disable-next-line
    }, [currentPage]);

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <Title icon="mdi mdi-clipboard-list-outline" label={translate('physical-confirmation:wrong-shed-monitor')} />
            </div>
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <ul id='collapsible' className="collapsible">
                        <li className='active'>
                            <div className="collapsible-header">
                                {translate('filters', 'general')}
                            </div>
                            <div className="collapsible-body" style={{ padding: '10px' }}>
                                <form id="getReport" className="col s12">
                                    <div className="row">
                                        <div className="input-field padding col s6">
                                            <Input
                                                defaultValue={filter.dateStart}
                                                type="date"
                                                label={translate('change-location:startDate')}
                                                id="dateStart"
                                                name="dateStart"
                                                onChange={onChange}
                                                required={!isNullOrEmpty(filter.dateEnd)}
                                            />
                                        </div>
                                        <div className="input-field padding col s5">
                                            <Input
                                                defaultValue={filter.dateEnd}
                                                type="date"
                                                label={translate('change-location:endDate')}
                                                id="dateEnd"
                                                name="dateEnd"
                                                onChange={onChange}
                                                required={!isNullOrEmpty(filter.dateStart)}
                                            />
                                        </div>
                                        <div className="input-field padding col s6">
                                            <Input
                                                id="partnumber"
                                                name='partnumber'
                                                placeholder={translate('physical-confirmation:part-number')}
                                                type="text"
                                                defaultValue={filter?.partnumber || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field padding col s5">
                                            <Input
                                                id="shed"
                                                name='shed'
                                                placeholder={translate('physical-confirmation:shed')}
                                                type="text"
                                                onChange={onChange}
                                                defaultValue={filter?.orderItemCode || ''}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </li>
                    </ul>
                    <div className="row" style={{ paddingTop: '5px' }}>
                        <Button full="true" text="Buscar" onClick={() => getTransmissionFilter(false, true)} />
                    </div>
                </div>
                <div id="listtransmissions">
                    <ListPaginationNew
                        page={props.transmissions?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={transmissions.map((item) => (
                            <ErrorShedMonitorItem item={item} />
                        ))}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        transmissions: state.physicalConfirmationReducer.transmissions
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTransmissions: (filter, callback) => {
            dispatch(PhysicalConfirmationService.getTransmissionsPaged(filter, callback));
        }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ErrorShedMonitorList)));
